// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Match login wizard tabs — override forgot_password global pill button styles */
.login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs li {
  /* removed stretch to match login page */
}

/* .login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button {
  background: none !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 8px 0 5px !important;
  margin: 0 !important;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  color: inherit !important;
  opacity: 0.55;
  position: relative;
  text-align: center;
  cursor: pointer;
  flex: 1 1;
} */

.login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active {
  opacity: 1;
  font-weight: 500;
}

.login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
  content: "";
  position: absolute;
  left: 36%;
  right: 36%;
  bottom: 0;
  height: 2px;
  background: #373737;
  border-radius: 2px;
}

body.light_theme .login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
  background: #373737;
}

@media screen and (max-width: 575px) {
  .login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {
    left: 12%;
    right: 12%;
  }

  .reset-password-page .reset-password-notice p {
    font-size: 11px;
  }

}

.reset-password-page .reset-password-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0 0 20px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(209, 170, 103, 0.12);
  border: 1px solid rgba(209, 170, 103, 0.28);
}

body.light_theme .reset-password-page .reset-password-notice {
  background: #fff8eb;
  border-color: #f0dfb8;
}

.reset-password-page .reset-password-notice i {
  font-size: 18px;
  color: #d1aa67;
  margin-top: 1px;
  flex-shrink: 0;
}

.reset-password-page .reset-password-notice p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.82);
}

body.light_theme .reset-password-page .reset-password-notice p {
  color: #5c4a2a;
}

.reset-password-page .reset-password-subtitle {
  margin: 0 0 18px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.72);
  text-align: center;
}

.reset-password-page .reset-password-subtitle--step2 {
  text-align: left;
  margin-bottom: 4px;
}

body.light_theme .reset-password-page .reset-password-subtitle {
  color: #64748b;
}

.reset-password-page .reset-password-login-link {
  text-align: center;
}

.reset-password-page .reset-password-login-link p {
  margin: 0;
}

.reset-password-page .reset-password-gate-hints {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reset-password-page .reset-password-gate-hints--empty .reset-password-gate-hint {
  opacity: 0.55;
}

.reset-password-page .reset-password-gate-hint {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
}

body.light_theme .reset-password-page .reset-password-gate-hint {
  color: #64748b;
}

.reset-password-page .reset-password-gate-hint i {
  font-size: 16px;
}

.reset-password-page .reset-password-gate-hint--ok {
  color: #22c55e;
}

.reset-password-page .reset-password-gate-hint--bad {
  color: #ef4444;
}

.reset-password-page .reset-password-gate-hint--idle i {
  color: rgba(255, 255, 255, 0.35);
}

body.light_theme .reset-password-page .reset-password-gate-hint--idle i {
  color: #cbd5e1;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ForgotPassword/reset-password.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,wCAAwC;AAC1C;;AAEA;;;;;;;;;;;;;;;GAeG;;AAEH;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Match login wizard tabs — override forgot_password global pill button styles */\n.login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs li {\n  /* removed stretch to match login page */\n}\n\n/* .login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button {\n  background: none !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  padding: 8px 0 5px !important;\n  margin: 0 !important;\n  font-size: 0.9rem !important;\n  font-weight: 500 !important;\n  color: inherit !important;\n  opacity: 0.55;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  flex: 1 1;\n} */\n\n.login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active {\n  opacity: 1;\n  font-weight: 500;\n}\n\n.login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 36%;\n  right: 36%;\n  bottom: 0;\n  height: 2px;\n  background: #373737;\n  border-radius: 2px;\n}\n\nbody.light_theme .login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n  background: #373737;\n}\n\n@media screen and (max-width: 575px) {\n  .login_section.forgot_password.reset-password-page .form_block_login.login-wizard-root .login-wizard-tabs button.is-active::after {\n    left: 12%;\n    right: 12%;\n  }\n\n  .reset-password-page .reset-password-notice p {\n    font-size: 11px;\n  }\n\n}\n\n.reset-password-page .reset-password-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0 0 20px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: rgba(209, 170, 103, 0.12);\n  border: 1px solid rgba(209, 170, 103, 0.28);\n}\n\nbody.light_theme .reset-password-page .reset-password-notice {\n  background: #fff8eb;\n  border-color: #f0dfb8;\n}\n\n.reset-password-page .reset-password-notice i {\n  font-size: 18px;\n  color: #d1aa67;\n  margin-top: 1px;\n  flex-shrink: 0;\n}\n\n.reset-password-page .reset-password-notice p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.82);\n}\n\nbody.light_theme .reset-password-page .reset-password-notice p {\n  color: #5c4a2a;\n}\n\n.reset-password-page .reset-password-subtitle {\n  margin: 0 0 18px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.72);\n  text-align: center;\n}\n\n.reset-password-page .reset-password-subtitle--step2 {\n  text-align: left;\n  margin-bottom: 4px;\n}\n\nbody.light_theme .reset-password-page .reset-password-subtitle {\n  color: #64748b;\n}\n\n.reset-password-page .reset-password-login-link {\n  text-align: center;\n}\n\n.reset-password-page .reset-password-login-link p {\n  margin: 0;\n}\n\n.reset-password-page .reset-password-gate-hints {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.reset-password-page .reset-password-gate-hints--empty .reset-password-gate-hint {\n  opacity: 0.55;\n}\n\n.reset-password-page .reset-password-gate-hint {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.65);\n}\n\nbody.light_theme .reset-password-page .reset-password-gate-hint {\n  color: #64748b;\n}\n\n.reset-password-page .reset-password-gate-hint i {\n  font-size: 16px;\n}\n\n.reset-password-page .reset-password-gate-hint--ok {\n  color: #22c55e;\n}\n\n.reset-password-page .reset-password-gate-hint--bad {\n  color: #ef4444;\n}\n\n.reset-password-page .reset-password-gate-hint--idle i {\n  color: rgba(255, 255, 255, 0.35);\n}\n\nbody.light_theme .reset-password-page .reset-password-gate-hint--idle i {\n  color: #cbd5e1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
